import { useMutation } from "@tanstack/react-query";
import {
  createOneTimeTransactionApi,
  deleteOneTimeTransactionApi,
  updateOneTimeTransactionApi,
} from "../../api/transaction/one-time";
import { OneTimeTransactionOrderPayload } from "../../types/transaction";
import { useInvalidateTransactionOrder } from "./invalidate";

export const useCreateOneTimeTransactionV2 = () => {
  return useMutation({
    mutationKey: ["transaction/one-time/create"],
    mutationFn: (payload: OneTimeTransactionOrderPayload) =>
      createOneTimeTransactionApi(payload),
  });
};

export const useCreateOneTimeTransaction = (variables: {
  investment_account_guid: string;
}) => {
  const { invalidate } = useInvalidateTransactionOrder(
    variables.investment_account_guid
  );

  return useMutation({
    mutationKey: ["transaction/one-time/create"],
    mutationFn: (payload: OneTimeTransactionOrderPayload) =>
      createOneTimeTransactionApi(payload),
    onSuccess: invalidate,
  });
};

export const useDeleteOneTimeTransaction = (variables: {
  investment_account_guid: string;
}) => {
  const { invalidate } = useInvalidateTransactionOrder(
    variables.investment_account_guid
  );

  return useMutation({
    mutationKey: ["transaction/one-time/delete"],
    mutationFn: deleteOneTimeTransactionApi,
    onSuccess: invalidate,
  });
};

export const useUpdateOneTimeTransaction = (variables: {
  investment_account_guid: string;
}) => {
  const { invalidate } = useInvalidateTransactionOrder(
    variables.investment_account_guid
  );

  return useMutation({
    mutationKey: ["transaction/one-time/update"],
    mutationFn: updateOneTimeTransactionApi,
    onSuccess: invalidate,
  });
};
